import Vue from 'vue';
// @ts-ignore
import VueParticles from 'vue-particles';
Vue.use(VueParticles);
